import 'core-js/stable';
import 'alpinejs';
import Bugsnag from '@bugsnag/js';
import { DateTime } from 'luxon';
import Echo from 'laravel-echo';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import parseDate from '@/date';

Bugsnag.start({
    apiKey: window.App.bugsnagKey,
    releaseStage: window.App.env,
    metaData: {
        user: window.App.user,
    },
});

library.add(fas, far, fal, fab);

dom.watch();

document.querySelectorAll('.alert.success').forEach((element) => {
    setTimeout(() => {
        element.remove();
    }, 2000);
});

function handleDelete(event) {
    event.preventDefault();
    const html = event.target.innerHTML;
    event.target.disabled = true;
    event.target.innerHTML = '<div class="spinner"><div class="bounce1 bg-red-400"></div><div class="bounce2 bg-red-400"></div><div class="bounce3 bg-red-400"></div></div>';
    if (window.confirm('Are you sure you want to archive?')) {
        const form = document.createElement('form'),
            csrf = document.createElement('input'),
            method = document.createElement('input');
        csrf.type = 'hidden';
        csrf.name = '_token';
        csrf.value = window.Laravel.csrfToken;
        method.type = 'hidden';
        method.name = '_method';
        method.value = 'DELETE';
        form.method = 'POST';
        form.action = event.target.href;
        form.appendChild(csrf);
        form.appendChild(method);
        document.body.appendChild(form);
        form.submit();
    } else {
        event.stopImmediatePropagation();
        event.target.innerHTML = html;
        event.target.disabled = false;
    }
}

document.body.addEventListener('click', (event) => {
    if (event.target && event.target.matches('.alert [role="button"]')) {
        event.target.closest('.alert').remove();
    }

    if (event.target && (event.target.matches('.button.delete') || event.target.matches('.text-red-500.delete'))) {
        handleDelete(event);
    }
});

function friendlyDates() {
    document.querySelectorAll('time[datetime]').forEach((element) => {
        const value = element.getAttribute('datetime'),
            date = parseDate(value);

        if (date === '') {
            element.innerText = '';
        }

        if (element.dataset.format !== undefined) {
            const format = JSON.parse(element.dataset.format);
            element.innerText = date.toLocaleString(format);
        } else if (element.dataset.noTime !== undefined) {
            element.innerText = date.toLocaleString({ ...DateTime.DATE_MED });
        } else if (element.dataset.noDate !== undefined) {
            element.innerText = date.toLocaleString({ ...DateTime.TIME_WITH_SHORT_OFFSET, second: false });
        } else {
            element.innerText = date.toLocaleString({ ...DateTime.DATETIME_MED });
        }
    });
}

document.addEventListener('livewire:load', () => {
    window.livewire.hook('afterDomUpdate', friendlyDates);
});

friendlyDates();

document.addEventListener('livewire:load', () => {
    window.livewire.on('pagination:change', () => {
        function scrollUp() {
            if (window.pageYOffset > 0) {
                window.scrollBy(0, -80);
                setTimeout(scrollUp, 0);
            }
        }

        scrollUp();
    });
});

if (window.App.pusherKey) {
    // eslint-disable-next-line global-require
    window.Pusher = require('pusher-js');

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: window.App.pusherKey,
        cluster: window.App.pusherCluster,
        forceTLS: true,
    });
}
